// extracted by mini-css-extract-plugin
module.exports = {"audio":"audio-controller_audio__13jfq"};